<ng-container [formGroup]="form" *ngIf="form">
  <div class="editer">
    <label *ngIf="label">{{ label }} <span>*</span></label>
    <ckeditor
      [editor]="Editor"
      [config]="config"
      *ngIf="isLayoutReady"
      [formControlName]="controlName"
      (ready)="onReady($event)"
    ></ckeditor>
  </div>
</ng-container>
